"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var color_schemes_1 = require("./color-schemes/color-schemes");
var typography_1 = require("./typography/typography");
var section_editor_1 = require("./section-editor/section-editor");
var partial_refresh_1 = require("./partial-refresh/partial-refresh");
wp.customize.bind('preview-ready', function () {
    new color_schemes_1.EpsilonColorSchemesPreviewer();
    new typography_1.EpsilonTypographyPreviewer();
    new section_editor_1.EpsilonSectionEditorPreviewer();
    new partial_refresh_1.EpsilonPartialRefresh();
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/previewer/previewer.ts
// module id = 45
// module chunks = 1